import React, { useEffect, useState } from "react";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import NotesDialog from "./NotesDialog";
import { Form, Row, Col, Accordion, Button, Dropdown } from "react-bootstrap";
import { IconDots, IconPencil, IconPlus, IconTrash } from "@tabler/icons-react";
import { toast } from "react-toastify";
import "./notes.css";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import ComanConfirmationModal from "../ComanConfirmationModal";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import notfoundData from "../../assets/notes_empty.json";
import moment from "moment";

function Notes({ module_type, module_id, status }) {
  const [isSelectNotes, setIsSelectNotes] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [usedSections, setUsedSections] = useState([]);
  const [addingNoteIndex, setAddingNoteIndex] = useState(null);
  const [newNote, setNewNote] = useState("");

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const isLocked = [
    // "WON",
    // "LOST",
    // "CANCELLED",
    // "PAID_CLOSED",
    // "DELIVERED",
  ].includes(status);

  const user = useSelector((state) => state.auth.user);

  const {
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "notes",
  });

  const { isLoading, postData: deleteNotes } = usePostRequest(
    API_ENDPOINTS.REMOVE_NOTE
  );
  const { isLoading: SectionLoading, postData: deleteSection } = usePostRequest(
    API_ENDPOINTS.REMOVE_SECTION
  );

  useEffect(() => {
    if (selectedSection && !usedSections.includes(selectedSection)) {
      const newSection = {
        section: selectedSection,
        custom_id: selectedSection,
        notesdata: [],
      };
      setValue("notes", [newSection, ...getValues("notes")]);
      setUsedSections((prev) => [selectedSection, ...prev]);
    }
  }, [selectedSection, append, usedSections, remove]);

  const handleSectionSelect = (section) => {
    setSelectedSection(section);
    const existingSections = getValues("notes") || [];
    const sectionExists = existingSections.some(
      (sec) => sec.section === section
    );

    if (!sectionExists) {
      const newSection = { section, notesdata: [] };
      setValue("notes", [newSection, ...existingSections]);
      setUsedSections((prev) => [section, ...prev]);
    }
  };

  // const handleAddNote = (sectionIndex) => {
  //   setAddingNoteIndex(sectionIndex);
  //   setNewNote("");
  // };

  const { rfq_id } = useParams();

  const [editingNote, setEditingNote] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState("");

  const {
    data,
    isLoading: notesLoading,
    postData: createNote,
  } = usePostRequest(API_ENDPOINTS.UPDATE_SINGLE_NOTE);

  // console.log(data.custom_id, "data custom id");

  console.log("status", status);

  const handleAddNote = (sectionIndex) => {
    setOpenSection(getValues("notes")[sectionIndex]?.section || null);
    setAddingNoteIndex(sectionIndex);
    setNewNote("");
    setEditingNote(null);
    setEditingNoteText("");
  };

  const handleEditNote = (sectionIndex, noteIndex, noteId) => {
    setEditingNote({ sectionIndex, noteIndex, noteId });
    setEditingNoteText(fields[sectionIndex].notesdata[noteIndex].note);
  };

  /* Notes on a locked order or on a product may be waiting for approval. */
  const [awaitingApproval, setAwaitingApproval] = useState([]);
  /* The section the reader is working in, so a save does not collapse it. */
  const [openSection, setOpenSection] = useState(null);

  /* Notes of this section that are still waiting for approval. */
  const pendingFor = (section) =>
    awaitingApproval.filter(
      (item) => (item.section || "").toLowerCase() === (section || "").toLowerCase(),
    );


  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES
  );

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section?.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    const pending = res?.pending || [];
    setAwaitingApproval(pending);

    const saved = res?.data ? transformData(res.data).notes : [];
    /* A note waiting for approval may be the only thing in its section — the
       section is shown anyway, so it reads like any other. */
    const extraSections = [...new Set(pending.map((item) => item.section).filter(Boolean))]
      .filter(
        (section) =>
          !saved.some(
            (item) => (item.section || "").toLowerCase() === section.toLowerCase(),
          ),
      )
      .map((section) => ({ section, custom_id: undefined, notesdata: [] }));

    if (res?.data || extraSections.length > 0) {
      /* Keep the order the reader already sees; only truly new sections
         are appended, so nothing jumps after a save. */
      const previous = (getValues("notes") || []).map((item) => (item.section || "").toLowerCase());
      const merged = [...saved, ...extraSections].sort((a, b) => {
        const first = previous.indexOf((a.section || "").toLowerCase());
        const second = previous.indexOf((b.section || "").toLowerCase());
        return (first === -1 ? previous.length : first) - (second === -1 ? previous.length : second);
      });
      setValue("notes", merged);
    }
  };

  const onSuccessCreate = (res) => {
    /* The note may be waiting for approval — the message says which. */
    if (res?.message) {
      toast.success(res.message);
    }
    fetchNotes(
      {
        module_id: module_id,
        module_type: module_type,
      },
      onSingleNotesSuccess
    );
  };

  const handleSubmitNote = (sectionIndex) => {
    setOpenSection(getValues("notes")[sectionIndex]?.section || null);
    if (editingNote) {
      const updatedNotes = [...getValues("notes")];
      updatedNotes[sectionIndex].notesdata[editingNote.noteIndex].note =
        editingNoteText;

      setValue("notes", updatedNotes);
      const payload = {
        module_id: module_id,
        module_type: module_type,
        section: getValues("notes")[sectionIndex]?.section,
        note: editingNoteText,
        custom_id: editingNote.noteId,
      };

      if (module_id) {
        createNote(payload, onSuccessCreate);
      }

      setEditingNote(null);
      setEditingNoteText("");
    } else {
      if (newNote.trim() !== "") {
        const updatedNotes = [...getValues("notes")];
        updatedNotes[sectionIndex].notesdata.push({ note: newNote });

        setValue("notes", updatedNotes);
        setAddingNoteIndex(null);
        setNewNote("");

        const payload = {
          module_id: module_id,
          module_type: module_type,
          section: getValues("notes")[sectionIndex]?.section,
          note: newNote,
          custom_id: null,
        };

        if (module_id) {
          createNote(payload, onSuccessCreate);
        }
      }
    }
  };

  const handleCancelNote = () => {
    setAddingNoteIndex(null);
    setNewNote("");
  };

  const onRemoveSuccess = (response) => {
    toast.success(response.message);
    fetchNotes(
      {
        module_id: module_id,
        module_type: module_type,
      },
      onSingleNotesSuccess
    );
  };
  const onRemoveError = (error) => {
    toast.error(error.message || "An error occurred during removing file.");
  };

  const removeSectionNote = (custom_id, sectionIndex) => {
    const currentNotes = getValues("notes");

    if (!custom_id) {
      remove(sectionIndex);
      setUsedSections((prev) =>
        prev.filter((sec) => sec !== getValues("notes")[sectionIndex]?.section)
      );
      return;
    }

    const updatedNotes = currentNotes.filter(
      (section) => section.custom_id !== custom_id
    );
    setValue("notes", updatedNotes);
    deleteSection(
      { custom_id: custom_id, module_type: module_type },
      onRemoveSuccess,
      onRemoveError
    );
  };

  const removeNote = (custom_id, sectionIndex, noteIndex) => {
    const currentNotes = getValues("notes");

    if (!custom_id) {
      const updatedNotes = currentNotes.map((section, idx) => {
        if (idx === sectionIndex) {
          return {
            ...section,
            notesdata: section.notesdata.filter(
              (_, noteIdx) => noteIdx !== noteIndex
            ),
          };
        }
        return section;
      });

      setValue("notes", updatedNotes);
      return;
    }

    const updatedNotes = currentNotes.map((section) => ({
      ...section,
      notesdata: section.notesdata.filter(
        (note) => note.custom_id !== custom_id
      ),
    }));

    setValue("notes", updatedNotes);

    deleteNotes(
      { custom_id: custom_id, module_type: module_type },
      onRemoveSuccess,
      onRemoveError
    );
  };

  const openModal = (custom_id, sectionIndex, noteIndex) => {
    let modalMessage = "Are you sure you want to delete this Note?";
    let modalTitle = "Delete Note";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let actionHandler = () => {
      removeNote(custom_id, sectionIndex, noteIndex);
    };
    let action = "delete";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const openModalSection = (custom_id, sectionIndex) => {
    let modalMessage = "Are you sure you want to delete this Section?";
    let modalTitle = "Delete Section";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let actionHandler = () => {
      removeSectionNote(custom_id, sectionIndex);
    };
    let action = "delete";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  console.log("the module id is ", module_id);

  return (
    <div>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      <NotesDialog
        isOpen={isSelectNotes}
        onClose={() => setIsSelectNotes(false)}
        handleSectionSelect={handleSectionSelect}
        fields={fields}
        getValues={getValues}
      />

      <Row className="justify-content-center">
        <Col md={11}>
          <Accordion
            className="contact_accordian"
            activeKey={
              openSection === null
                ? 0
                : fields.findIndex(
                    (item) =>
                      (item.section || "").toLowerCase() === openSection.toLowerCase(),
                  )
            }
            onSelect={(key) =>
              setOpenSection(key === null ? "" : fields[Number(key)]?.section || null)
            }
          >
            {fields.length > 0 ? (
              fields.map((item, sectionIndex) => (
                <>
                  <Accordion.Item eventKey={sectionIndex} key={sectionIndex}>
                    <Accordion.Header>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <span>{item.section}</span>
                        {item?.custom_id && (
                        <span
                          className={`badge btn-sm bg-pink-lt btn-outline-danger badge-outline me-3 
                          ${isLocked ? "status-disabled" : ""}`}
                          onClick={() => {
                            if (
                              status === "WON" ||
                              status === "LOST" ||
                              status === "CANCELLED"
                            )
                              return;
                            openModalSection(item?.custom_id, sectionIndex);
                          }}
                        >
                          Delete Section
                        </span>
                        )}

                        {/* <span
                          className="badge btn-sm bg-pink-lt btn-outline-danger badge-outline me-3"
                          onClick={() =>
                            openModalSection(item?.custom_id, sectionIndex)
                          }
                        >
                          Delete Section
                        </span> */}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="user_note_body">
                      <ul className="p-0 user_list_items">
                        {pendingFor(item.section).map((pendingItem, pendingIndex) => (
                          <li
                            key={`pending-${pendingIndex}`}
                            className="d-flex justify-content-between"
                            style={{ opacity: 0.75 }}
                          >
                            <div className="edit_notes_item">
                              <div>
                                <div className="user_note_info">
                                  <span>{pendingItem.requested_by || user.username}</span>
                                  <p className="mb-0">
                                    {moment(pendingItem.requested_at).format("MM/DD/YYYY HH:mm")}
                                  </p>
                                </div>
                                <p className="mb-0">{pendingItem.note}</p>
                              </div>
                            </div>
                            <span
                              style={{
                                alignSelf: "center",
                                fontSize: 11,
                                fontWeight: 700,
                                color: "#c2410c",
                                background: "#fff4e5",
                                borderRadius: 999,
                                padding: "3px 9px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Pending approval
                            </span>
                          </li>
                        ))}
                        {item.notesdata && item.notesdata.length > 0 ? (
                          item.notesdata.map((noteItem, noteIndex) => (
                            <li
                              as={Row}
                              key={noteIndex}
                              className="d-flex justify-content-between"
                            >
                              <div className="edit_notes_item">
                                {editingNote &&
                                editingNote.sectionIndex === sectionIndex &&
                                editingNote.noteIndex === noteIndex ? (
                                  <Form.Control
                                    as="textarea"
                                    style={{ height: "80px" }}
                                    value={editingNoteText}
                                    onChange={(e) =>
                                      setEditingNoteText(e.target.value)
                                    }
                                  />
                                ) : (
                                  <div>
                                    <div className="user_note_info">
                                      <span>
                                        {noteItem.user
                                          ? noteItem.user
                                          : user.username}
                                      </span>
                                      <p className="mb-0">
                                        {noteItem.updateAt
                                          ? moment(noteItem.updateAt).format(
                                              "MM/DD/YYYY HH:mm"
                                            )
                                          : new Date().toLocaleString()}
                                      </p>
                                    </div>
                                    <p className="mb-0 note_datas">
                                      {noteItem.note}
                                    </p>
                                  </div>
                                )}
                                {editingNote &&
                                editingNote.sectionIndex === sectionIndex &&
                                editingNote.noteIndex === noteIndex ? (
                                  <div className="d-flex gap-1 align-items-center">
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() =>
                                        handleSubmitNote(sectionIndex)
                                      }
                                    >
                                      Save
                                    </Button>
                                    <Button
                                      variant="outline-secondary"
                                      size="sm"
                                      className="ms-2"
                                      onClick={() => setEditingNote(null)}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                ) : (
                                  <>
                                    <Dropdown className="notes_dropdown">
                                      <Dropdown.Toggle
                                        id="dropdown-basic"
                                        className={
                                          isLocked ? "status-disabled" : ""
                                        }
                                      >
                                        <IconDots />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleEditNote(
                                              sectionIndex,
                                              noteIndex,
                                              noteItem.custom_id
                                            )
                                          }
                                        >
                                          <IconPencil /> Edit Note
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            openModal(
                                              noteItem.custom_id,
                                              sectionIndex,
                                              noteIndex
                                            )
                                          }
                                        >
                                          <IconTrash /> Delete Note
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </>
                                )}
                              </div>
                            </li>
                          ))
                        ) : (
                          <></>
                        )}
                      </ul>

                      {addingNoteIndex !== sectionIndex && !editingNote && (
                        <div className="text-center">
                          <Button
                            type="button"
                            className="add_sku_button btn mt-2"
                            onClick={() => handleAddNote(sectionIndex)}
                            disabled={isLocked}
                          >
                            Add a Note
                          </Button>
                        </div>
                      )}

                      {addingNoteIndex === sectionIndex && (
                        <Form.Group as={Row}>
                          <div className="user_note_info">
                            <span>{user.username}</span>
                            {/* <p className="mb-0">
                              {new Date().toLocaleString()}
                            </p> */}
                            <p className="mb-0">
                              {new Date().toLocaleString(undefined, {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </p>
                          </div>
                          <div className="edit_notes_item">
                            <Form.Control
                              as="textarea"
                              style={{ height: "80px" }}
                              value={newNote}
                              onChange={(e) => setNewNote(e.target.value)}
                              placeholder="Enter your note"
                            />
                            <div className="d-flex gap-1 align-items-center">
                              <Button
                                variant="success"
                                onClick={() => handleSubmitNote(sectionIndex)}
                              >
                                Submit
                              </Button>
                              <Button
                                variant="outline-secondary"
                                onClick={handleCancelNote}
                              >
                                Cancel
                              </Button>
                            </div>
                          </div>
                        </Form.Group>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* {errors.notes &&
                    errors.notes[sectionIndex]?.notesdata?.message && (
                      <span className="text-danger text-center">
                        {errors.notes[sectionIndex].notesdata.message}
                      </span>
                    )} */}
                </>
              ))
            ) : (
              <></>
            )}
          </Accordion>
          {fields.length == 0 ? (
            <div className="empty_notes text-center">
              <div className="notes_icons">
                {" "}
                <Lottie
                  height={150}
                  width={150}
                  animationData={notfoundData}
                />{" "}
              </div>
              <p> No sections added yet.</p>
            </div>
          ) : (
            <></>
          )}
          <div
            className={`add_notes_button ${isLocked ? "status-disabled" : ""} `}
            onClick={() => setIsSelectNotes(true)}
          >
            <span className="icon-add-border">
              <IconPlus />
            </span>
            Add a note section
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Notes;
